import HeaderBar from "../../../Components/UI/headerbar";
import AdminsTab from "../../systemsettings/admins";

const AdminsPage = () => {
  return (
    <div>
      <HeaderBar title={" المشرفين "} content={"إدارة   المشرفين "} />

      <AdminsTab />
    </div>
  );
};

export default AdminsPage;
